import React, { useMemo } from 'react';
import { createArrayInRange, LinkButton, Row } from '@visalex/core';

import cx from 'clsx';
import { useTranslation } from 'next-i18next';

import Benefits, { BenefitProps } from '../../Benefits/Benefits';

import commonStyles from '../Technology.module.scss';
import styles from './Advantages.module.scss';

const prefix = 'technology';

const Advantages = () => {
  const { t, i18n } = useTranslation();

  const benefits: BenefitProps[] = useMemo(
    () =>
      createArrayInRange(0, 3).map((index) => ({
        key: index,
        title: t(`${prefix}.advantages.benefits.${index}.title`),
        description: t(`${prefix}.advantages.benefits.${index}.description`),
        imageName: `${prefix}/advantages/icon_${index + 1}.svg`,
      })),
    [i18n.language]
  );

  return (
    <Row className={styles[`${prefix}__advantages`]}>
      <h3 className={styles[`${prefix}__advantages_title`]}>{t(`${prefix}.advantages.title`)}</h3>
      <p className={cx(commonStyles[`${prefix}__subtitle`], styles[`${prefix}__advantages_subtitle`])}>
        {t(`${prefix}.advantages.subtitle`)}
      </p>
      <Benefits benefits={benefits} colProps={{ xs: 12, md: 6, xl: 3 }} />
      <LinkButton size="lg" href="/why-visalex" outline className="mx-3">
        {t(`${prefix}.advantages.learn-more-btn`)}
      </LinkButton>
    </Row>
  );
};

export default Advantages;
